let maskPlaceholder = '+7 (999) 999-99-99';

window.initPhoneMask = function() {
  $('.js-mask').each(function(index, element) {
    const _this = $(element);

    if(_this.data('mask')){
      maskPlaceholder = _this.data('mask');
    }

    _this.inputmask({'mask': maskPlaceholder});
  });
}

$(document).on('keydown', '.js-mask', function(event){
  if(event.which === 32) return false;
});

// fix ios focus input
$(document).one('focus', '.js-mask', function() {
  const _this = $(this)
  setTimeout(function() {
    _this[0].setSelectionRange(4, 4);
  }, 50)
});

initPhoneMask();